import { jsx as r, Fragment as i } from "react/jsx-runtime";
import h from "../PaginationLink/PaginationLink.mjs";
import { PaginationLinkVariants as d } from "../PaginationLink/PaginationLinkVariants.mjs";
import { cn as g } from "../../../lib/utils.mjs";
import n from "../../Icon/Icon.mjs";
const u = ({
  className: o,
  variant: e = "default",
  disabled: a = !1,
  size: t = "sm",
  isActive: s = !1,
  url: l,
  paginationParam: m = "page",
  page: p,
  as: c = "link",
  ...f
}) => /* @__PURE__ */ r(i, { children: a ? /* @__PURE__ */ r(i, { children: /* @__PURE__ */ r(
  "span",
  {
    role: "button",
    "aria-label": "previous page",
    className: g(
      d({
        variant: e,
        size: t,
        disabled: a,
        active: s
      }),
      o
    ),
    "aria-disabled": a,
    children: /* @__PURE__ */ r(
      n,
      {
        icon: "material-symbols--arrow-forward-ios-rounded",
        width: 4,
        height: 4,
        disabled: a,
        className: "flex-shrink-0 en:rotate-180"
      }
    )
  }
) }) : /* @__PURE__ */ r(i, { children: /* @__PURE__ */ r(
  h,
  {
    "aria-label": "previous page",
    variant: e,
    disabled: a,
    className: o,
    size: "sm",
    url: l,
    page: p,
    paginationParam: m,
    as: c,
    ...f,
    children: /* @__PURE__ */ r(
      n,
      {
        icon: "material-symbols--arrow-forward-ios-rounded",
        width: 4,
        height: 4,
        className: "flex-shrink-0 en:rotate-180",
        variant: "primary"
      }
    )
  }
) }) });
u.displayName = "PaginationPrevious";
export {
  u as default
};
//# sourceMappingURL=PaginationPrevious.mjs.map
